module.exports = __webpack_public_path__ + "img/Edit-assumptions.5c70635e.svg";